import AuthRemindPasswordComponent from './AuthRemindPasswordComponent';
import { RemindPasswordConnectorApollo } from '@front-activerse/common-components';

const AuthRemindPasswordPage = () => {
  const isLoggedIn = !!localStorage.getItem('token');

  return (
    <RemindPasswordConnectorApollo>
      {({ ...remindPassword }) => (
        <AuthRemindPasswordComponent {...remindPassword} isLoggedIn={isLoggedIn} />
      )}
    </RemindPasswordConnectorApollo>
  );
};

export default AuthRemindPasswordPage;
